import { doesSearchMatch } from '../SearchHighlightText/utils';
import type { ExpiringPriorAuthTableRow, PriorAuthReviewSummary } from '../../api';
import { MIN_SEARCH_LENGTH } from '../../constants';
import { formatStandardDate } from 'shared-utils/utils/formatDate';

/**
 * Filter function for ExpiringPriorAuthTableRow used in search preview and table filtering.
 * Searches: patient name, prescriber name, drug name, DOB
 */
export const filterExpiringPriorAuth = (row: ExpiringPriorAuthTableRow, searchTerm: string): boolean => {
  if (!searchTerm || searchTerm.length < MIN_SEARCH_LENGTH) return true;

  return (
    doesSearchMatch(searchTerm, row.rx?.patient_name, 'name') ||
    doesSearchMatch(searchTerm, row.rx?.prescriber_name, 'name') ||
    doesSearchMatch(searchTerm, row.drug_name, 'text') ||
    doesSearchMatch(searchTerm, row.formatted_dob, 'date')
  );
};

/**
 * Filter function for PriorAuthReviewSummary used in search preview and table filtering.
 * Searches: patient name, drug name, DOB
 */
export const filterPriorAuthReview = (row: PriorAuthReviewSummary, searchTerm: string): boolean => {
  if (!searchTerm || searchTerm.length < MIN_SEARCH_LENGTH) return true;

  // Format patient_dob to MM/DD/YYYY for consistent date matching
  const formattedDob = row.patient_dob ? formatStandardDate(row.patient_dob) : null;

  return (
    doesSearchMatch(searchTerm, row.patient_name, 'name') ||
    doesSearchMatch(searchTerm, row.drug_name, 'text') ||
    doesSearchMatch(searchTerm, formattedDob, 'date')
  );
};
